import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../Context/AuthContext';
import { ComponentSpinner } from '../Loading/ComponentSpinner';

// MSAL normally navigates on to the requested page itself; this covers the moment before, and a direct visit.
export const EntraLoginCallback = () => {
  const { authState } = useAuth();

  if (!authState?.isPending) {
    return (
      <Navigate
        to="/"
        replace
      />
    );
  }

  return (
    <div className="flex h-[70vh]">
      <ComponentSpinner
        sx={{ mt: 'auto' }}
        label="Signing you in..."
      />
    </div>
  );
};
